import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const fetchBankMonitoring = ({ filter, scopeId, date, tirage }) =>
  apiRequest(`/banks/monitoring/${toQuery({ filter, scope: scopeId, date, tirage })}`);
